import axios from "axios";
import { Edit, Plus, Search, Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Header";

const AdminBlogTable = () => {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 5;
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token"));

  // Filter blogs based on search
  const filteredBlogs = blogs.filter(
    (blog) =>
      blog.title.toLowerCase().includes(search.toLowerCase()) ||
      blog.author.toLowerCase().includes(search.toLowerCase())
  );

  // Get current blogs
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = (id) => {
    // Implement delete functionality
    try {
      const response = fetch(`http://localhost:5000/api/blogs/${id}`, {
        method: "DELETE",
      });
      console.log(response);

      setBlogs(blogs.filter((blog) => blog._id !== id));
    } catch {
      console.log("Error deleting blog:");
    }
  };

  const handleEdit = (id) => {
    // Navigate to edit page
    navigate(`/blog/edit/${id}`);
  };

  const handleAddNew = () => {
    // Navigate to add new blog page
    navigate("/blog/add");
  };
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch("http://localhost:5000/api/blogs");
        const data = await response.json();
        setBlogs(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchBlogs();
  }, []);
  useEffect(() => {
    const checkToken = async () => {
      try {
        const response = await axios.post(
          "http://localhost:5000/api/verify",
          null,
          {
            headers: {
              auth: token,
            },
          }
        );
        response.data.message === "Verified"
          ? console.log("Token verified")
          : console.log("Token not verified");
      } catch (error) {
        console.error("Error verifying token:", error);
        navigate("/login");
      }
    };
    checkToken();
  }, [token]);

  return (
    <>
      <Navbar />
      <div className="mb-4 lg:mx-20 xl:mx-20 md:mx-15 sm:mx-auto p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Admin Blog Dashboard</h1>
          <button
            onClick={handleAddNew}
            className="bg-teal-500 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded flex items-center"
          >
            <Plus className="mr-2" size={20} /> Add New Blog
          </button>
        </div>

        <div className="mb-4 flex items-center">
          <Search className="mr-2" size={20} />
          <input
            type="text"
            placeholder="Search blogs..."
            className="border p-2 rounded w-full"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="flex justify-center ">
          <table className="min-w-full bg-white">
            <thead>
              <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                <th className="py-3 px-6 text-center">Blog Name</th>
                <th className="py-3 px-6 text-center">Author</th>
                <th className="py-3 px-6 text-center">Created At</th>
                <th className="py-3 px-6 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light">
              {currentBlogs &&
                currentBlogs.map((blog) => (
                  <tr
                    key={blog.id}
                    className="border-b border-gray-200 hover:bg-gray-100"
                  >
                    <td className="py-3 px-6 text-center whitespace-nowrap">
                      {blog.title}
                    </td>
                    <td className="py-3 px-6 text-center">{blog.author}</td>
                    <td className="py-3 px-6 text-center">{blog.createdAt}</td>
                    <td className="py-3 px-6 text-center">
                      <div className="flex item-center justify-center">
                        <button
                          onClick={() => handleEdit(blog._id)}
                          className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
                        >
                          <Edit size={16} />
                        </button>
                        <button
                          onClick={() => handleDelete(blog._id)}
                          className="w-4 mr-2 transform hover:text-red-500 hover:scale-110"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-center mt-4">
          {[
            ...Array(Math.ceil(filteredBlogs.length / blogsPerPage)).keys(),
          ].map((number) => (
            <button
              key={number + 1}
              onClick={() => paginate(number + 1)}
              className={`mx-1 px-3 py-1 rounded ${
                currentPage === number + 1
                  ? "bg-teal-500 text-white"
                  : "bg-gray-200"
              }`}
            >
              {number + 1}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default AdminBlogTable;
